/*################################################################
                        Bootstrap
################################################################*/
import Vue from 'vue';

try {
    // safety loader
    if(!window.$) {
        window.$ = window.jQuery = require('jquery');
    }
} catch (e) {}

Vue.config.productionTip = false;


/*################################################################
                    Define all Components
################################################################*/
// Vue.component('hello', require('./vue/components/Hello.vue').default);
Vue.component('shoppingcart', require('./components/Shoppingcart.vue').default);
Vue.component('quick-buys', require('./components/QuickBuys.vue').default);
Vue.component('quick-buys-alt', require('./components/QuickBuysAlt.vue').default);


/*################################################################
Due to script tags in the middle of the content we need to
initiate seperate components.
################################################################*/

if(document.getElementById('shoppingcart')) {
    const header = new Vue({
        el: '#shoppingcart'
    });
}

if(document.getElementById('quick_buys')) {
    const quickBuys = new Vue({
        el: '#quick_buys'
    });
}

if(document.getElementById('quick_buys_alt')) {
    const quickBuysAlt = new Vue({
        el: '#quick_buys_alt'
    });
}

